import { useDateTimeFormat } from '~/hooks';

export default function ProjectHealthReportDetails({ projectHealthReport }) {
  const dateTimeFormat = useDateTimeFormat();

  return projectHealthReport?.date ? dateTimeFormat.format(projectHealthReport.date) : 'No date';
}
